"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\n\t/* Needed to avoid transition out on stroke calculation */\n\t", ";\n\t", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", " {\n\t\ttransition: all 0.7s ease-in;\n\t}\n\n\t", " {\n\t\ttransition: all 0.2s ease-in;\n\t}\n\n\t", " {\n\t\ttransition: all 0.3s ease-in;\n\t}\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", " {\n\t\tstroke-dashoffset: 0 !important;\n\t}\n\t", " {\n\t\ttransition-delay: 1s;\n\t\tstroke-dashoffset: 0 !important;\n\t}\n\t", " {\n\t\ttransition-delay: 0.7s;\n\t\tstroke-dashoffset: 0 !important;\n\t}\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Swish = _styledComponents.default.path(_templateObject());

Swish.displayName = 'Swish';

var Short = _styledComponents.default.path(_templateObject2());

Short.displayName = 'Short';

var Long = _styledComponents.default.path(_templateObject3());

Long.displayName = 'Long';
var animation = (0, _styledComponents.css)(_templateObject4(), Swish, Short, Long);
var transitions = (0, _styledComponents.css)(_templateObject5(), Swish, Short, Long);

var Wrapper = _styledComponents.default.svg(_templateObject6(), function (props) {
  return props.color;
}, function (props) {
  return props.computed && transitions;
}, function (props) {
  return props.animate && animation;
});

Wrapper.displayName = 'Wrapper';

var XingLoader = function XingLoader(_ref) {
  var size = _ref.size,
      color = _ref.color;

  var _useState = (0, _react.useState)(false),
      computed = _useState[0],
      setComputed = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      animate = _useState2[0],
      setAnimate = _useState2[1];

  var swish = (0, _react.useRef)();
  var short = (0, _react.useRef)();
  var long = (0, _react.useRef)();
  (0, _react.useLayoutEffect)(function () {
    var els = [swish, short, long];
    els.forEach(function (el) {
      var len = el.current.getTotalLength();
      el.current.style.strokeDashoffset = len;
      el.current.style.strokeDasharray = len;
    });
    setTimeout(function () {
      setComputed(true);
      setAnimate(true);
    });
  }, [size]);
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      return setAnimate(function (anim) {
        return !anim;
      });
    }, 2000);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  return _react.default.createElement(Wrapper, {
    width: size - 1,
    height: size,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    animate: animate,
    computed: computed,
    color: color
  }, _react.default.createElement(Short, {
    d: "M7.5 9.5C9.33333 10.8333 12 14.4 12 16",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    ref: short
  }), _react.default.createElement(Long, {
    d: "M2 24.5C13 15.5 18 11.3 30 6.5",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: long
  }), _react.default.createElement(Swish, {
    d: "M2.5 18.0001C7.16667 17.0001 16.9867 15.5 23 15.5C27.5 15.5 17.5 24.5 7 31C10.1667 22.3333 11 16.5445 19 2",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: swish
  }));
};

XingLoader.displayName = 'XingLoader';
XingLoader.defaultProps = {
  size: 60,
  color: '#0057ad'
};
XingLoader.propTypes = {
  size: _propTypes.number,
  color: _propTypes.string
};
var _default = XingLoader;
exports.default = _default;